import _uniq from "lodash.uniq";
function uniq(array) {
  return _uniq(array);
}
export {
  uniq
};
//# sourceMappingURL=uniq.mjs.map
